export default "__VITE_ASSET__BpH4Dfia__"